import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgChevronLeft = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-chevron-left", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Chevron Left Icon'),
    React.createElement("path", { fill: "currentColor", d: "M13.706 20.708a.988.988 0 0 0 0-1.406l-7.243-7.173a.198.198 0 0 1 0-.281l7.216-7.15c.392-.388.42-1.018.028-1.406a1.01 1.01 0 0 0-1.42 0l-7.782 7.68c-.682.675-.662 1.373-.008 2.02l7.79 7.716a1.01 1.01 0 0 0 1.419 0" }))); };
var Memo = memo(SvgChevronLeft);
export default Memo;
//# sourceMappingURL=ChevronLeft.js.map